import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { A11y, Navigation, Pagination } from "swiper/core";
import { arrayOf, node, shape, string } from "prop-types";
import { useEffect, useState } from "react";

import React from "react";
import StyledLink from "../StyledLink/StyledLink.jsx";
import cx from "classnames";
import useMatchMedia from "../../common/useMatchMedia.js";

const propTypes = {
  title: string,
  description: node,
  promos: arrayOf(
    shape({
      eyebrow: string,
      title: string.isRequired,
      description: string.isRequired,
      images: arrayOf(
        shape({ src: string.isRequired, alt: string.isRequired }),
      ),
      link: string.isRequired,
      linkClass: string,
      linkTarget: string,
    }).isRequired,
  ).isRequired,
};

const MultiPromoA = (props) => {
  const { title, description, promos } = props;

  const [renderSwipers, setRenderSwipers] = useState(false);

  useEffect(() => {
    //required to let text load and prevent swiper init errors
    setRenderSwipers(true);
  }, []);

  //matches bp-large-min in breakpoints.scss
  const isDesktop = useMatchMedia("(min-width: 1060px)");

  SwiperCore.use([A11y, Pagination, Navigation]);

  const renderDesktop = (promos) => {
    return (
      <div className="multi-promo-a__desktop-container">
        {renderSwipers &&
          promos.map((promo, i) => (
            <div
              key={i}
              className={cx("multi-promo-a__promo", {
                "multi-promo-a__promo--reverse": i % 2 !== 0,
              })}
            >
              {i % 2 === 0 ? (
                <React.Fragment>
                  <div className="multi-promo-a__slide-content">
                    {promo.eyebrow && (
                      <div
                        className="multi-promo-a__eyebrow"
                        data-aos="border-grow"
                        data-aos-once="true"
                      >
                        {promo.eyebrow}
                      </div>
                    )}
                    {promo.title && (
                      <div className="multi-promo-a__slide-title">
                        {promo.link && (
                          <StyledLink
                            href={promo.link}
                            target={promo.linkTarget}
                          >
                            {promo.title}
                          </StyledLink>
                        )}
                        {!promo.link && promo.title}
                      </div>
                    )}
                    {promo.description && (
                      <div className="multi-promo-a__slide-desc">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: promo.description,
                          }}
                        ></div>
                      </div>
                    )}
                  </div>
                  <Swiper
                    a11y
                    pagination={{ clickable: true }}
                    observer={true}
                    observeParents={true}
                    slidesPerView={1}
                    navigation={promo.images.length > 1 ? true : false}
                  >
                    {promo.images.map((image, j) => (
                      <SwiperSlide key={j}>
                        <img src={image.src} alt={image.alt} loading="lazy" />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Swiper
                    a11y
                    pagination={{ clickable: true }}
                    observer={true}
                    observeParents={true}
                    slidesPerView={1}
                    navigation={promo.images.length > 1 ? true : false}
                  >
                    {promo.images.map((image, k) => (
                      <SwiperSlide key={image.src + k}>
                        <img src={image.src} alt={image.alt} loading="lazy" />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className="multi-promo-a__slide-content">
                    {promo.eyebrow && (
                      <div
                        className="multi-promo-a__eyebrow"
                        data-aos="border-grow"
                        data-aos-once="true"
                      >
                        {promo.eyebrow}
                      </div>
                    )}
                    {promo.title && (
                      <div className="multi-promo-a__slide-title">
                        <StyledLink href={promo.link} target={promo.linkTarget}>
                          {promo.title}
                        </StyledLink>
                      </div>
                    )}
                    {promo.description && (
                      <div
                        className="multi-promo-a__slide-desc"
                        dangerouslySetInnerHTML={{
                          __html: promo.description,
                        }}
                      ></div>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
          ))}
      </div>
    );
  };

  const renderMobile = (promos) => (
    <div className="container container--bleed">
      {renderSwipers &&
        promos.map((promo, i) => (
          <div key={i} className="multi-promo-a__promo">
            <>
              <div className="multi-promo-a__slide-content">
                {promo.eyebrow && (
                  <div
                    className="multi-promo-a__eyebrow"
                    data-aos="border-grow"
                    data-aos-once="true"
                  >
                    {promo.eyebrow}
                  </div>
                )}
                {promo.title && (
                  <div className="multi-promo-a__slide-title">
                    <StyledLink href={promo.link} target={promo.linkTarget}>
                      {promo.title}
                    </StyledLink>
                  </div>
                )}
                {promo.description && (
                  <div
                    className="multi-promo-a__slide-desc"
                    dangerouslySetInnerHTML={{
                      __html: promo.description,
                    }}
                  ></div>
                )}
              </div>
              <Swiper
                a11y
                observer={true}
                observeParents={true}
                pagination={{ clickable: true }}
                navigation={promo.images.length > 1 ? true : false}
                slidesPerView={1}
              >
                {promo.images.map((image, j) => (
                  <SwiperSlide key={j}>
                    <img src={image.src} alt={image.alt} loading="lazy" />
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          </div>
        ))}
    </div>
  );

  return (
    <>
      {!isDesktop && (
        <div className="multi-promo__hr">
          <hr data-aos="border-grow" data-aos-once="true" />
        </div>
      )}
      <section className="multi-promo-a">
        <div className="multi-promo-a__header">
          {title && <h2 className="multi-promo-a__title">{title}</h2>}
          {description && (
            <div className="multi-promo-b__description">
              <div dangerouslySetInnerHTML={{ __html: description }}></div>
            </div>
          )}
        </div>
        {isDesktop ? renderDesktop(promos) : renderMobile(promos)}
      </section>
    </>
  );
};

MultiPromoA.propTypes = propTypes;
export default MultiPromoA;
